
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exclusives/login",
      function () {
        return require("private-next-pages/exclusives/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exclusives/login"])
      });
    }
  